export interface ConversationIntentI {
  id?: string;
  text: string;
  responseMessage: string;
  done: boolean;
  chunks: string[];
  lastChunk?: string;
  thoughts?: string;
}

export interface ConversationI {
  id: string;
  projectId: string;
  userId: string;
  intents: ConversationIntentI[];
}

export interface TokenUsageDetailsI {
  outputTokens: number;
  totalTokens: number;
  inputTokens: number;
}

export interface TokensUsageI {
  tokenUsage: TokenUsageDetailsI;
  totalTokens: number;
  messageCount: number;
}

export interface ConversationsStateI {
  conversation: ConversationI;
  tokensUsage: TokensUsageI;
  modelVersion: string;
}

export const state: ConversationsStateI = {
  conversation: {
    id: '',
    projectId: '',
    userId: '',
    intents: [],
  },
  modelVersion: 'root_agent',
  tokensUsage: {
    tokenUsage: {
      outputTokens: 0,
      totalTokens: 0,
      inputTokens: 0,
    },
    totalTokens: 0,
    messageCount: 0,
  },
};
